import {yup} from '@driscollsinc/style-guide-web2.0';

export const SiteSchema = yup.object().shape({
    selectedRegion: yup.string().required('Region is required'),
    selectedSite: yup.string().required('Site is required'),
    selectedWarehouses: yup.array().required('Warehouses are required'),
  });